<template>
  <div class="container-fluid">
    <div class="container">
      <div class="row m-4">
        <div class="col">
          <a class="anchor text-dark" name="about">
            <h1 class="display-3 text-center m-4" data-aos="fade" data-aos-easing="ease-in">About Me</h1>
          </a>
          <p
            data-aos="fade"
            data-aos-easing="ease-in"
          >I put my first website together way back in the early days of angelfire and geocities pages, and I've been at it ever since. The tools and technologies have changed since then, but the satisfaction of building something that works and putting it out into the world is something I still feel every time I publish a new project.</p>
        </div>
      </div>
      <h2 class="text-center" data-aos="fade" data-aos-easing="ease-in">Tech Toolbox</h2>
      <div class="row m-4">
        <div class="card-columns">
          <div class="card mt-2" data-aos="fade" data-aos-easing="ease-in">
            <div class="card-body">
              <div
                class="card-title h4 text-center p-2 bg-secondary text-light"
              >Technologies &amp; Frameworks</div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item text-center">NodeJS</li>
                <li class="list-group-item text-center">ExpressJS</li>
                <li class="list-group-item text-center">Django/Flask</li>
                <li class="list-group-item text-center">VueJS</li>
                <li class="list-group-item text-center">Bootstrap</li>
                <li class="list-group-item text-center">jQuery</li>
                <li class="list-group-item text-center">Wordpress</li>
                <li class="list-group-item text-center">Nginx</li>
                <li class="list-group-item text-center">Git</li>
                <li class="list-group-item text-center">Docker</li>
              </ul>
            </div>
          </div>
          <div class="card mt-2" data-aos="fade" data-aos-easing="ease-in">
            <div class="card-body">
              <div class="card-title h4 text-center p-2 bg-secondary text-light">Languages</div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item text-center">Javascript/Typescript</li>
                <li class="list-group-item text-center">Python</li>
                <li class="list-group-item text-center">PHP</li>
                <li class="list-group-item text-center">HTML</li>
                <li class="list-group-item text-center">CSS</li>
              </ul>
            </div>
          </div>
          <div class="card mt-2" data-aos="fade" data-aos-easing="ease-in">
            <div class="card-body">
              <div class="card-title h4 text-center p-2 bg-secondary text-light">Database &amp; ORM</div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item text-center">DynamoDB</li>
                <li class="list-group-item text-center">MongoDB</li>
                <li class="list-group-item text-center">MySQL</li>
                <li class="list-group-item text-center">PostgreSQL</li>
                <li class="list-group-item text-center">SQLAlchemy</li>
                <li class="list-group-item text-center">MongooseJS</li>
              </ul>
            </div>
          </div>
          <div class="card mt-2" data-aos="fade" data-aos-easing="ease-in">
            <div class="card-body">
              <div class="card-title h4 text-center p-2 bg-secondary text-light">Cloud Platforms</div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item text-center">AWS</li>
                <li class="list-group-item text-center">Digital Ocean</li>
                <li class="list-group-item text-center">Azure</li>
              </ul>
            </div>
          </div>
          <div class="card mt-2" data-aos="fade" data-aos-easing="ease-in">
            <div class="card-body">
              <div class="card-title h4 text-center p-2 bg-secondary text-light">Creative</div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item text-center">Photoshop</li>
                <li class="list-group-item text-center">Lightroom</li>
                <li class="list-group-item text-center">Illustrator</li>
                <li class="list-group-item text-center">Premiere Pro</li>
                <li class="list-group-item text-center">After Effects</li>
                <li class="list-group-item text-center">Audition</li>
                <li class="list-group-item text-center">InDesign</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>